<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="telDirections"
      :items="telDirections"
      :fields="telDirectionsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="telDirectionsTotal" :perPage="perPage"
      v-model="currentPage"/>
      <editModal @update="update" :editItem="selectedTelDirections"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID'},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'create_date', label: this.$i18n.t('Created on'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'zones', label: this.$i18n.t('Zone')},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix')},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix')},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ],
      selectedTelDirections: null,
      options: {
        isShowAddButton: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    update () {
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': 0, 'filter': this.filter})
      } else {
        this.currentPage = 1
      }
    },
    showAdd () {
      this.selectedTelDirections = {
        called_prefix: '',
        called_prefix_regexp: true,
        calling_prefix: '',
        calling_prefix_regexp: true,
        dir_coverage_type: 0,
        dir_id: 0,
        incoming_trunk: '',
        name: '',
        outgoing_trunk: '',
        pbx_id: '',
        skip: false,
        zone_id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneDirections', '#btnShow')
      this.perPage = 20
      this.currentPage = 1
    },
    async editItem (item) {
      await this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS', item.dir_id).then(response => {
        this.selectedTelDirections = this.$store.getters['Tariffing/TEL_DIRECTIONS']
      })
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneDirections', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Telephone directions"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TEL_DIRECTIONS', item.dir_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (this.currentPage - 1) * this.perPage, 'filter': this.filter})
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (this.currentPage - 1) * this.perPage, 'filter': value})
      } else {
        this.currentPage = 1
      }
    },
    paginationChanged (value) {
      this.perPage = value
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': value, 'offset': 0, 'filter': this.filter})
      } else {
        this.currentPage = 1
      }
    }
  },
  computed: {
    telDirections () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'])).items
      for (let el of copy) {
        for (let elZone of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))) {
          if (el.zone_id === elZone.zone_id) {
            el.zones = elZone.name + ' (' + elZone.zone_id + ')'
            break
          }
        }
      }
      return copy
    },
    telDirectionsTotal () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].total))
    }
  },
  watch: {
    currentPage (val) {
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (val - 1) * this.perPage, 'filter': this.filter})
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
    this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': 0, 'filter': ''})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneDirections/main.vue